import React from 'react';
import Aux from '../../../../hoc/_Aux';
import blueWaveForm from './../../../../assets/images/svg/blue-wave.svg';

const TinyJellyShape = (props) => {
    let shapeStyle = {};
    let translate = "center";
    if(typeof props.translate !== "undefined" )
    {
        translate = props.translate;
    }

    let embedSVG = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='1 0 381 126'>";
          embedSVG+= " <path class='blue-wave' fill='"+props.color+"' d='M382.2,0c-0.5,0.9,11.8,120.7,0.3,121c-14.5,3.7-27.1-49.9-47.8-49.9s-31.1,43.2-49.4,43.2";
          embedSVG+= " c-18.5,0-17.8-11.8-32.7-14.2c-20.7-0.8-32.5,28.8-46.4,26.6c-14-0.6-23-24.1-43.6-26.6c-13.4-3.2-24.1,12.6-63.8,21.9";
          embedSVG+= " c-26.5,5-41.5-18-44.9-25.9c-10.5-24.3-17.9-22.7-24-7.5S13.6,124,0.6,121c-0.4-11.6-0.1-15.7,0.1-15.3C0.7,105,0,20.5,0,0.2";
          embedSVG+= " L382.2,0z'/>";
          embedSVG+= "</svg>";

    // #Ticket 3303, for Firefox, embedded SVG works only if there are encoded with base64 algorithm. 
    const embedSVGEncoded = btoa(embedSVG); // encode into base64     

    if(props.color==='gradient'){
        shapeStyle = {
            "background":
              [
                //@TODO : https://stackoverflow.com/questions/32100495/how-do-i-apply-vendor-prefixes-to-inline-styles-in-reactjs
                // "-webkit-linear-gradient(180deg, rgba(119,78,255,1) 0%, rgba(37,23,88,1) 100%)",
                // "-o-linear-gradient(180deg, rgba(119,78,255,1) 0%, rgba(37,23,88,1) 100%)",
                // "-moz-linear-gradient(180deg, rgba(119,78,255,1) 0%, rgba(37,23,88,1) 100%)",
                "linear-gradient(180deg, rgba(119,78,255,1) 0%, rgba(37,23,88,1) 100%)",
              ],
            "WebkitMask":  `url(${blueWaveForm}) ${translate} center repeat-x`,
            "mask": `url(${blueWaveForm}) ${translate} center repeat-x`
        };
    }
    else {
        shapeStyle = {
            //"background": `url(${blueWaveForm}) center center repeat-x`,
            //"backgroundColor": `${props.color}`,
            //"fill":`${props.color}`,
            "background": `url("data:image/svg+xml;utf8;base64,${embedSVGEncoded}") center -24px repeat-x`
            //"WebkitMask":  `url(${blueWaveForm}) ${translate} center repeat-x`, 
            //"mask": `url(${blueWaveForm}) ${translate} center repeat-x`
        }
    }
    const shapeOutput = (<div className="tiny-jelly-curve" style={shapeStyle} />);

    return(
      <Aux>
            {shapeOutput}
      </Aux>
    );
};

export default TinyJellyShape;


// WEBPACK FOOTER //
// ./src/containers/UI/Common/JellyShape/TinyJellyShape.js